import { __extends } from "tslib";
import { Rectangle, Point } from '@awayjs/core';
import { Filter3DTaskBase } from './Filter3DTaskBase';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var EMPTY_TRANSFORM = new Float32Array([1, 1, 1, 1, 0, 0, 0, 0]);
var Filter3DCopyPixelTask = /** @class */ (function (_super) {
    __extends(Filter3DCopyPixelTask, _super);
    function Filter3DCopyPixelTask() {
        var _this = _super.call(this) || this;
        _this.rect = new Rectangle();
        _this.destPoint = new Point();
        _this._vertexConstantData = new Float32Array([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
        _this._fragConstantData = EMPTY_TRANSFORM.slice();
        return _this;
    }
    Object.defineProperty(Filter3DCopyPixelTask.prototype, "sourceTexture", {
        get: function () {
            return this._mainInputTexture;
        },
        set: function (value) {
            this._mainInputTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    Filter3DCopyPixelTask.prototype.getVertexCode = function () {
        var temp1 = this._registerCache.getFreeVertexVectorTemp();
        var rect = this._registerCache.getFreeVertexConstant();
        var position = this._registerCache.getFreeVertexAttribute();
        this._positionIndex = position.index;
        var offset = this._registerCache.getFreeVertexConstant();
        var uv = this._registerCache.getFreeVertexAttribute();
        this._uvIndex = uv.index;
        this._uvVarying = this._registerCache.getFreeVarying();
        var code = 'mul ' + temp1 + '.xy, ' + position + ', ' + rect + '.zw\n' +
            'add ' + temp1 + '.xy, ' + temp1 + ', ' + rect + '.xy\n' +
            'mov ' + temp1 + '.w, ' + position + '.w\n' +
            'mov op, ' + temp1 + '\n' +
            'add ' + this._uvVarying + ', ' + uv + ', ' + offset + '.xy\n' +
            'mul ' + this._uvVarying + ', ' + this._uvVarying + ', ' + offset + '.zw\n';
        return code;
    };
    Filter3DCopyPixelTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp2, 1);
        var mulltipler = this._registerCache.getFreeFragmentConstant();
        var add = this._registerCache.getFreeFragmentConstant();
        var inputTexture = this._registerCache.getFreeTextureReg();
        this._inputTextureIndex = inputTexture.index;
        var code = 'tex ' + temp1 + ', ' + this._uvVarying + ', ' + inputTexture + ' <2d,linear,clamp>\n' +
            'sat ' + temp2 + ', ' + mulltipler + '\n' +
            'mul ' + temp1 + ', ' + temp1 + ', ' + temp2 + '.xyzw\n' +
            // premult a addited color too
            'mul ' + temp2 + ', ' + add + ', ' + temp1 + '.w\n' +
            'add ' + temp1 + ', ' + temp1 + ', ' + temp2 + '.xyzw\n' +
            'mov oc, ' + temp1 + '\n';
        return code;
    };
    Filter3DCopyPixelTask.prototype.getMainInputTexture = function (stage) {
        return this._mainInputTexture;
    };
    Filter3DCopyPixelTask.prototype.activate = function (stage, projection, depthTexture) {
        var index = this._positionIndex;
        var vd = this._vertexConstantData;
        var dp = this.destPoint;
        var sr = this.rect;
        var tr = this._target;
        var tex = this._mainInputTexture;
        // mul to vertex
        vd[index + 0] = (2 * dp.x + sr.width) / tr.width - 1;
        vd[index + 1] = (2 * dp.y + sr.height) / tr.height - 1;
        // add to vertex
        vd[index + 2] = sr.width / tr.width;
        vd[index + 3] = sr.height / tr.height;
        // add to uv
        vd[index + 4] = sr.x / sr.width;
        vd[index + 5] = sr.y / sr.height;
        // mul to uv
        vd[index + 6] = sr.width / tex.width;
        vd[index + 7] = sr.height / tex.height;
        var fd = EMPTY_TRANSFORM;
        if (this.transform) {
            fd = this._fragConstantData;
            fd.set(this.transform._rawData);
            for (var i = 0; i < 4; i++)
                fd[i + 4] /= 255;
            // disable ALPHA offset, because can't allowed in PMA mode
            fd[7] = 0;
        }
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, vd);
        context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, fd);
    };
    Filter3DCopyPixelTask.prototype.deactivate = function (stage) {
    };
    return Filter3DCopyPixelTask;
}(Filter3DTaskBase));
export { Filter3DCopyPixelTask };
